$(document).on('fetchedStockinfo', (event, itemId) => {
  $(`#stock-lots-${itemId}`).foundation();
});
